import Data from './CarouselData';

const CarouselSidebar = (props) => {
  return <Data {...props} />;
};

export default CarouselSidebar;
